import { InputAdornment, TextField } from "@mui/material";
import { blockInvalidChar } from "utils/Regex";
import EditIcon from "assets/images/Edit.svg";

export const CustomInvoiceTextfield = ({
  name,
  invoiceDetails,
  setInvoiceDetails,
  adormentStartType,
  adormentEndType,
  adornmentStart,
  adornmentEnd,
  adorment,
  customClass,
  handleExtraCalculationCharges
}) => {
  const handleChange = (fieldName, event) => {
    setInvoiceDetails({ ...invoiceDetails, [fieldName]: event.target.value });
  };

  const handleAdorement = (adornment) => {
    switch (adornment) {
      case "rupee":
        return "₹";
      case "km":
        return "KM";
      case "edit":
        return <img src={EditIcon} alt="Edit Icon" />
      default:
        return;
    }
  };

  const handleOnFocus = (event) => {
    const {name, value} = event.target;
      setInvoiceDetails({ ...invoiceDetails, [name]: Number(value) > 0 ? Number(value) : 0 });
  }

  const onHandleBlur = (event) => {
    const {name, value} = event.target;
    if(name === "extraKm" || name === "extraDays") {
      handleExtraCalculationCharges(name, value);
    }
      setInvoiceDetails({ ...invoiceDetails, [name]: Number(value) > 0 ? Number(value) : 0 });
  }
const onHandleClick = (e) =>{
  e.stopPropagation();
  const inputField = document.querySelector(`input[name="${name}"]`);
  if (inputField) {
    inputField.focus();
  }
}
  return (
    <TextField
      name={name}
      value={invoiceDetails?.[name]}
      type="number"
      onFocus={(e) => handleOnFocus(e)}
      onChange={(e) => handleChange(name, e)}
      onKeyDown={(e) => blockInvalidChar(e)}
      onBlur={(e) => onHandleBlur(e)}
      className={`modalTextfield ${customClass}`}
      InputProps={{
        startAdornment: adornmentStart && (
          <InputAdornment position="start" role="presentation">
            {handleAdorement(adormentStartType)}
          </InputAdornment>
        ),
        endAdornment: adornmentEnd && (
          <InputAdornment  onClick={onHandleClick}  position="end" role="presentation">
            {handleAdorement(adormentEndType)}
          </InputAdornment>
        ),
      }}
    />
  );
};
